import Tibbit_00_1 from '@appblocks/codegeneration/Tibbits/Tibbit_00_1/Tibbit_00_1';
import TibbitNtios_00_1 from '@appblocks/codegeneration/Tibbits/Tibbit_00_1/TibbitNtios_00_1';
import Tibbit_00_2 from '@appblocks/codegeneration/Tibbits/Tibbit_00_2';
import Tibbit_00_3 from '@appblocks/codegeneration/Tibbits/Tibbit_00_3';
import Tibbit_01 from '@appblocks/codegeneration/Tibbits/Tibbit_01';
import Tibbit_02 from '@appblocks/codegeneration/Tibbits/Tibbit_02';
import Tibbit_03_1 from '@appblocks/codegeneration/Tibbits/Tibbit_03_1';
import Tibbit_03_2 from '@appblocks/codegeneration/Tibbits/Tibbit_03_2';
import Tibbit_04_1 from '@appblocks/codegeneration/Tibbits/Tibbit_04_1';
import Tibbit_04_2 from '@appblocks/codegeneration/Tibbits/Tibbit_04_2';
import Tibbit_04_3 from '@appblocks/codegeneration/Tibbits/Tibbit_04_3';
import Tibbit_04_4 from '@appblocks/codegeneration/Tibbits/Tibbit_04_4';
import Tibbit_04_5 from '@appblocks/codegeneration/Tibbits/Tibbit_04_5';
import Tibbit_04_6 from '@appblocks/codegeneration/Tibbits/Tibbit_04_6';
import Tibbit_04_7 from '@appblocks/codegeneration/Tibbits/Tibbit_04_7';
import Tibbit_04_8 from '@appblocks/codegeneration/Tibbits/Tibbit_04_8';
import Tibbit_05 from '@appblocks/codegeneration/Tibbits/Tibbit_05';
import Tibbit_06 from '@appblocks/codegeneration/Tibbits/Tibbit_06';
import Tibbit_07 from '@appblocks/codegeneration/Tibbits/Tibbit_07';
import Tibbit_08 from '@appblocks/codegeneration/Tibbits/Tibbit_08';
import Tibbit_11 from '@appblocks/codegeneration/Tibbits/Tibbit_11';
import Tibbit_13 from '@appblocks/codegeneration/Tibbits/Tibbit_13';
import Tibbit_14 from '@appblocks/codegeneration/Tibbits/Tibbit_14';
import Tibbit_15 from '@appblocks/codegeneration/Tibbits/Tibbit_15';
import Tibbit_22 from '@appblocks/codegeneration/Tibbits/Tibbit_22';
import Tibbit_31 from '@appblocks/codegeneration/Tibbits/Tibbit_31';
import Tibbit_16 from '@appblocks/codegeneration/Tibbits/Tibbit_16';
import Tibbit_17 from '@appblocks/codegeneration/Tibbits/Tibbit_17';
import Tibbit_28 from '@appblocks/codegeneration/Tibbits/Tibbit_28';
import Tibbit_29 from '@appblocks/codegeneration/Tibbits/Tibbit_29';
import Tibbit_30 from '@appblocks/codegeneration/Tibbits/Tibbit_30';
import Tibbit_33 from '@appblocks/codegeneration/Tibbits/Tibbit_33';
import Tibbit_35 from '@appblocks/codegeneration/Tibbits/Tibbit_35';
import Tibbit_36 from '@appblocks/codegeneration/Tibbits/Tibbit_36';
import Tibbit_38 from '@appblocks/codegeneration/Tibbits/Tibbit_38';
import Tibbit_39_1 from '@appblocks/codegeneration/Tibbits/Tibbit_39_1';
import Tibbit_39_2 from '@appblocks/codegeneration/Tibbits/Tibbit_39_2';
import Tibbit_39_3 from '@appblocks/codegeneration/Tibbits/Tibbit_39_3';
import Tibbit_39_4 from '@appblocks/codegeneration/Tibbits/Tibbit_39_4';
import Tibbit_40_1 from '@appblocks/codegeneration/Tibbits/Tibbit_40_1';
import Tibbit_40_2 from '@appblocks/codegeneration/Tibbits/Tibbit_40_2';
import Tibbit_40_3 from '@appblocks/codegeneration/Tibbits/Tibbit_40_3';
import Tibbit_40_4 from '@appblocks/codegeneration/Tibbits/Tibbit_40_4';
import Tibbit_41 from '@appblocks/codegeneration/Tibbits/Tibbit_41';
import Tibbit_42 from '@appblocks/codegeneration/Tibbits/Tibbit_42';
import Tibbit_43_1 from '@appblocks/codegeneration/Tibbits/Tibbit_43_1';
import Tibbit_43_2 from '@appblocks/codegeneration/Tibbits/Tibbit_43_2';
import Tibbit_44_1 from '@appblocks/codegeneration/Tibbits/Tibbit_44_1';
import Tibbit_44_2 from '@appblocks/codegeneration/Tibbits/Tibbit_44_2';
import Tibbit_45 from '@appblocks/codegeneration/Tibbits/Tibbit_45';
import Tibbit_46 from '@appblocks/codegeneration/Tibbits/Tibbit_46';
import Tibbit_52 from '@appblocks/codegeneration/Tibbits/Tibbit_52';
import Tibbit_53 from '@appblocks/codegeneration/Tibbits/Tibbit_53';
import Tibbit_54 from '@appblocks/codegeneration/Tibbits/Tibbit_54';
import Tibbit_57 from '@appblocks/codegeneration/Tibbits/Tibbit_57';
import Tibbit_58 from '@appblocks/codegeneration/Tibbits/Tibbit_58';
import Tibbit_59 from '@appblocks/codegeneration/Tibbits/Tibbit_59';
import Tibbit_61_1 from '@appblocks/codegeneration/Tibbits/Tibbit_61_1';
import Tibbit_61_2 from '@appblocks/codegeneration/Tibbits/Tibbit_61_2';
import Tibbit_63_1 from '@appblocks/codegeneration/Tibbits/Tibbit_63_1';
import Tibbit_63_2 from '@appblocks/codegeneration/Tibbits/Tibbit_63_2';
import Tibbit_26 from '@appblocks/codegeneration/Tibbits/Tibbit_26';
import Tibbit_62 from '@appblocks/codegeneration/Tibbits/Tibbit_62';
import LTPP3G2_sockets from '@appblocks/platforms/boards/tibbo/LTPP3G2/LTPP3G2_sockets.json';
import LTPP3_sockets from '@appblocks/platforms/boards/tibbo/LTPP3/LTPP3_sockets.json';
import TPP2G2_sockets from '@appblocks/platforms/boards/tibbo/TPP2W(G2)/TPP2W(G2)_sockets.json';
import TPP3G2_sockets from '@appblocks/platforms/boards/tibbo/TPP3W(G2)/TPP3W(G2)_sockets.json';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import { SocketConfig, TibboBasicEnum } from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';


const SocketsMap: { [platformId: string]: Array<SocketConfig> } = {
    'TPP3W(G2)': TPP3G2_sockets,
    'TPP2W(G2)': TPP2G2_sockets,
    'TPP2W(G3)': TPP2G2_sockets,
    'TPP3W(G3)': TPP3G2_sockets,
    LTPP3: LTPP3_sockets,
    LTPP3G2: LTPP3G2_sockets,
};

const TibbitsMap: { [tibbitId: string]: any } = {
    tibbit_00_1: {
        tios: Tibbit_00_1,
        simulator: Tibbit_00_1,
        ntios: TibbitNtios_00_1,
    },
    tibbit_00_2: Tibbit_00_2,
    tibbit_00_3: Tibbit_00_3,
    tibbit_01: Tibbit_01,
    tibbit_02: Tibbit_02,
    tibbit_03_1: Tibbit_03_1,
    tibbit_03_2: Tibbit_03_2,
    tibbit_04_1: Tibbit_04_1,
    tibbit_04_2: Tibbit_04_2,
    tibbit_04_3: Tibbit_04_3,
    tibbit_04_4: Tibbit_04_4,
    tibbit_04_5: Tibbit_04_5,
    tibbit_04_6: Tibbit_04_6,
    tibbit_04_7: Tibbit_04_7,
    tibbit_04_8: Tibbit_04_8,
    tibbit_05: Tibbit_05,
    tibbit_06: Tibbit_06,
    tibbit_07: Tibbit_07,
    tibbit_08: Tibbit_08,
    tibbit_11: Tibbit_11,
    tibbit_13: Tibbit_13,
    tibbit_14: Tibbit_14,
    tibbit_15: Tibbit_15,
    tibbit_16: Tibbit_16,
    tibbit_17: Tibbit_17,
    tibbit_22: Tibbit_22,
    tibbit_26: Tibbit_26,
    tibbit_28: Tibbit_28,
    tibbit_29: Tibbit_29,
    tibbit_30: Tibbit_30,
    tibbit_31: Tibbit_31,
    tibbit_33: Tibbit_33,
    tibbit_35: Tibbit_35,
    tibbit_36: Tibbit_36,
    tibbit_38: Tibbit_38,
    tibbit_39_1: Tibbit_39_1,
    tibbit_39_2: Tibbit_39_2,
    tibbit_39_3: Tibbit_39_3,
    tibbit_39_4: Tibbit_39_4,
    tibbit_40_1: Tibbit_40_1,
    tibbit_40_2: Tibbit_40_2,
    tibbit_40_3: Tibbit_40_3,
    tibbit_40_4: Tibbit_40_4,
    tibbit_41: Tibbit_41,
    tibbit_42: Tibbit_42,
    tibbit_43_1: Tibbit_43_1,
    tibbit_43_2: Tibbit_43_2,
    tibbit_44_1: Tibbit_44_1,
    tibbit_44_2: Tibbit_44_2,
    tibbit_45_1: Tibbit_45,
    tibbit_45_2: Tibbit_45,
    tibbit_45_3: Tibbit_45,
    tibbit_46: Tibbit_46,
    tibbit_52: Tibbit_52,
    tibbit_53: Tibbit_53,
    tibbit_54: Tibbit_54,
    tibbit_57: Tibbit_57,
    tibbit_58: Tibbit_58,
    tibbit_59: Tibbit_59,
    tibbit_61_1: Tibbit_61_1,
    tibbit_61_2: Tibbit_61_2,
    tibbit_62: Tibbit_62,
    tibbit_63_1: Tibbit_63_1,
    tibbit_63_2: Tibbit_63_2,
};

export default class Tibbits {
    static getItem(itemId: string, project: ProjectConfiguration) {
        if (TibbitsMap[itemId] !== undefined) {
            if (project.runtime
                && TibbitsMap[itemId][project.runtime] !== undefined) {
                return new TibbitsMap[itemId][project.runtime]();
            }
            return new TibbitsMap[itemId](itemId);
        }

        if (itemId !== undefined && itemId.indexOf('tibbit_') === 0) {
            const tibbit = new BaseTibbit();
            tibbit.id = itemId;
            tibbit.name = itemId;
            return tibbit;
        }
        return undefined;
    }

    static getList() {
        return Object.keys(TibbitsMap);
    }

    static getSocketPins(socketId: string, platformId: string): Array<string> {
        const socketList = SocketsMap[platformId];

        for (let i = 0; i < socketList.length; i += 1) {
            if (socketList[i].socket === socketId) {
                return socketList[i].pins;
            }
        }
        return [];
    }

    static getSocketPinNumbers(socketId: string, platformId: string): Array<string> {
        const socketList = SocketsMap[platformId];
        try {
            for (let i = 0; i < socketList.length; i += 1) {
                if (socketList[i].socket === socketId
                    && socketList[i].pin_numbers !== undefined) {
                    return socketList[i].pin_numbers as Array<string>;
                }
            }
        } catch (ex) {
            //
        }
        return ['', '', '', ''];
    }

    static getSocket(socketId: string, platformId: string): SocketConfig | undefined {
        const socketList = SocketsMap[platformId];
        for (let i = 0; i < socketList.length; i += 1) {
            if (socketList[i].socket === socketId) {
                return socketList[i];
            }
        }
        return undefined;
    }
}
